<template>
    <div class="hello">
        <el-button type="primary">hello {{ msg }} 按钮</el-button>
    </div>
</template>

<script>

export default {
    name: 'DapHello',
    props: {
        msg: String,
    },
}
</script>

<style scoped lang="scss">
.hello {
    margin: 10px auto;
    color: #42b983;
}
</style>
